import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Theme } from '@domgen/dgx-fe-common';
import {
  DescriptionListComponent,
  DescriptionListItemComponent,
} from '@domgen/dgx-fe-components/list';
import {
  PanelBorderRadius,
  PanelComponent,
} from '@domgen/dgx-fe-components/panel';
import {
  DateFormatPipe,
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@domgen/dgx-fe-i18n';
import {
  LocallyStoredRegistrationData,
  RegistrationApplianceDetails,
  RegistriaUserResponse,
} from '@us-registration/util-models';
import { translation } from '../../i18n/translation.constant';
import { RegistrationRegistriaSnippetComponent } from '../registration-registria-snippet/registration-registria-snippet.component';

@Component({
  selector: 'us-registration-confirmation-appliance-details-panel',
  standalone: true,
  imports: [
    DateFormatPipe,
    DescriptionListComponent,
    DescriptionListItemComponent,
    NgIf,
    PanelComponent,
    TranslatePipe,
    RegistrationRegistriaSnippetComponent,
  ],
  templateUrl:
    './registration-confirmation-appliance-details-panel.component.html',
  styleUrls: [
    './registration-confirmation-appliance-details-panel.component.scss',
  ],
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class RegistrationConfirmationApplianceDetailsPanelComponent {
  @Input() title?: string;
  @Input() variant: Theme = 'background';
  @Input() border = false;
  @Input() registeredAppliance?:
    | LocallyStoredRegistrationData
    | RegistrationApplianceDetails;

  @Input() registriaUserResponse?: RegistriaUserResponse;
  @Input() rounded?: PanelBorderRadius = 'lg';
  @Input() stacked?: boolean;
}
